
$(document).ready(function() {
    let bikUser = '';
    let korChetUser = '';
    let bankName = '';
    let bank_index = '';
    let bank_city = '';
    let bank_address = '';
    let bank_phone = '';

    var $inputBik = $('#card__bik-new');
    var prefixBik = '04';
    var maxLengthBik = 9; // БИК состоит из 9 цифр

    if ($inputBik.length) {
        // Установка плейсхолдера
        $inputBik.attr('placeholder', '04xxxxxxx');

        // Обработчик события фокуса
        $inputBik.on('focus', function() {
            var value = $(this).val();

            // Если поле пустое, добавляем префикс
            if (value === '') {
                $(this).val(prefixBik);

                // Устанавливаем курсор после префикса
                setCaretPosition(this, prefixBik.length);
            }
        });

        // Обработчик события ввода
        $inputBik.on('input', function() {
            var value = $(this).val();

            // Удаляем все нецифровые символы
            value = value.replace(/\D/g, '');

            // Ограничиваем длину до 9 цифр
            if (value.length > maxLengthBik) {
                value = value.slice(0, maxLengthBik);
            }

            $(this).val(value);
        });

        // Обработчик события клавиш
        $inputBik.on('keydown', function(e) {
            var cursorPosition = this.selectionStart;
            var value = $(this).val();

            // Разрешаем удаление части префикса
            if (
                (
                    e.key === 'Backspace' &&
                    cursorPosition <= prefixBik.length &&
                    value.startsWith(prefixBik)
                ) ||
                (
                    e.key === 'Delete' &&
                    cursorPosition < prefixBik.length &&
                    value.startsWith(prefixBik)
                )
            ) {
                if (cursorPosition === 1) {
                    e.preventDefault();
                    $(this).val('').trigger('input');
                }
            }
        });

        // Обработчик потери фокуса для валидации
        $inputBik.on('blur', function() {
            var value = $(this).val();
            var regex = /^04\d{7}$/;
            var $errorMessage = $(this).siblings('.error-message');

            if (value !== '' && !regex.test(value)) {
                $(this).addClass('error');
                $errorMessage.show();
            } else {
                $(this).removeClass('error');
                $errorMessage.hide();
            }
        });

        // Обработчик вставки БИК
        $inputBik.on('paste', function(e) {
            e.preventDefault();

            var pastedData = e.originalEvent.clipboardData.getData('text');

            // Удаляем все нецифровые символы
            pastedData = pastedData.replace(/\D/g, '');

            // Ограничиваем длину до 9 цифр
            pastedData = pastedData.slice(0, maxLengthBik);

            $(this).val(pastedData).trigger('input');
        });

        // Функция установки позиции курсора
        function setCaretPosition(ctrl, pos) {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(pos, pos);
            } else if (ctrl.createTextRange) {
                var range = ctrl.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        }
    }

    // ========================================
    // Проверка БИК через DaData Proxy
    // ========================================

    var bikRequest = null;
    var bikRequestId = 0;

    // Управление состоянием кнопки продолжения
    function updateContinueButton() {
        var number = String(
            $('#card__number-new').val() || ''
        ).replace(/\D/g, '');

        var currentBik = String($inputBik.val() || '');

        var isValidBank =
            bikUser === currentBik &&
            Boolean(korChetUser) &&
            bankName.toLowerCase().includes('сбербанк');

        var enabled = isValidBank && number.length === 20;

        $('.js-button-number, .button--score')
            .toggleClass('button--in-active', !enabled);
    }

    // Сброс данных банка
    function resetBankData() {
        bikUser = '';
        korChetUser = '';
        bankName = '';

        $('#card__number-new').prop('disabled', true);

        updateContinueButton();
    }

    // Запрос банка по БИК
    function checkBankByBik(bikValue) {
        var requestId = ++bikRequestId;

        bikRequest = $.ajax({
            type: 'POST',
            url: '/ajax/dadata-proxy-bik',
            contentType: 'application/json',
            dataType: 'json',

            // Новое тело запроса
            data: JSON.stringify({
                query: bikValue
            }),

            success: function(response) {
                // Игнорируем устаревшие ответы
                if (
                    requestId !== bikRequestId ||
                    String($inputBik.val()) !== bikValue
                ) {
                    return;
                }

                // Получаем банк из suggestions
                var suggestion = Array.isArray(
                    response && response.suggestions
                )
                    ? response.suggestions.find(function(item) {
                        return (
                            item &&
                            item.data &&
                            item.data.bic === bikValue
                        );
                    })
                    : null;

                // Название банка берём из unrestricted_value
                var name = suggestion && suggestion.unrestricted_value;

                // Данные банка
                var bankData = suggestion && suggestion.data;

                // Проверяем наличие банка и принадлежность Сбербанку
                if (
                    !name ||
                    !name.toLowerCase().includes('сбербанк') ||
                    !bankData.correspondent_account
                ) {
                    resetBankData();
                    sendCardNumberError();
                    return;
                }

                // Сохраняем данные банка
                bikUser = bankData.bic;
                korChetUser = bankData.correspondent_account;
                bankName = name;

                // Разблокируем поле расчётного счёта
                $('#card__number-new').prop('disabled', false);

                // Обновляем состояние кнопки
                updateContinueButton();
            },

            error: function(xhr, status) {
                // Не обрабатываем отменённые запросы
                if (
                    status === 'abort' ||
                    requestId !== bikRequestId
                ) {
                    return;
                }

                resetBankData();

                console.error(
                    'Ошибка получения банка по БИК:',
                    xhr
                );

                $('.number__error--bik').show();
            }
        });
    }

    // Обработчик изменения БИК
    $inputBik.on('input change', function() {
        $('.number__error').hide();

        // Инвалидируем предыдущий запрос
        ++bikRequestId;

        // Отменяем предыдущий запрос
        if (bikRequest) {
            bikRequest.abort();
            bikRequest = null;
        }

        // Сбрасываем данные предыдущего банка
        resetBankData();

        var bikValue = String(
            $inputBik.val() || ''
        ).replace(/\D/g, '');

        // Запрашиваем данные только при корректном формате БИК
        if (/^04\d{7}$/.test(bikValue)) {
            checkBankByBik(bikValue);
        }
    });

    // ========================================
    // Отправка ошибки валидации БИК
    // ========================================

    function sendCardNumberError() {
        $('.number__error--bik').show();

        $.ajax({
            type: 'POST',
            url: '/ajax/card-number-validation-error',

            data: {
                'card-number': $('[name ="card-number"]').val(),
                'bik': $('[name ="card-bik"]').val(),
                'kor_number': '',
                'bank_name': ''
            },

            dataType: 'json',

            success: function() {
                console.log('Вы ошиблись');
            },

            error: function(error) {
                console.log(error);
            }
        });
    }

    // ========================================
    // Расчётный счёт
    // ========================================

    var $inputNumber = $('#card__number-new');
    var prefixNumber = '4081';
    var maxLengthNumber = 20;

    if ($inputNumber.length) {
        // Установка плейсхолдера
        $inputNumber.attr(
            'placeholder',
            '4081xxxxxxxxxxxxxxxx'
        );

        // Обработчик события фокуса
        $inputNumber.on('focus', function() {
            var value = $(this).val();

            if (value === '') {
                $(this).val(prefixNumber);

                setCaretPosition(
                    this,
                    prefixNumber.length
                );
            }
        });

        // Обработчик события ввода
        $inputNumber.on('input', function() {
            var value = $(this).val();

            // Удаляем все нецифровые символы
            value = value.replace(/\D/g, '');

            // Ограничиваем длину до 20 символов
            if (value.length > maxLengthNumber) {
                value = value.slice(0, maxLengthNumber);
            }

            $(this).val(value);
        });

        // Обработчик удаления префикса
        $inputNumber.on('keydown', function(e) {
            var cursorPosition = this.selectionStart;
            var value = $(this).val();

            if (
                (
                    e.key === 'Backspace' &&
                    cursorPosition <= prefixNumber.length &&
                    value.startsWith(prefixNumber)
                ) ||
                (
                    e.key === 'Delete' &&
                    cursorPosition < prefixNumber.length &&
                    value.startsWith(prefixNumber)
                )
            ) {
                if (cursorPosition === 1) {
                    e.preventDefault();
                    $(this).val('').trigger('input');
                }
            }
        });

        // Обработчик потери фокуса
        $inputNumber.on('blur', function() {
            var value = $(this).val();
            var regex = /^4081\d{16}$/;
            var $errorMessage = $(this).siblings('.error-message');

            if (
                value !== '' &&
                !regex.test(value)
            ) {
                $(this).addClass('error');
                $errorMessage.show();
            } else {
                $(this).removeClass('error');
                $errorMessage.hide();
            }
        });

        // Обработчик вставки расчётного счёта
        $inputNumber.on('paste', function(e) {
            e.preventDefault();

            var pastedData = e.originalEvent.clipboardData.getData('text');

            pastedData = pastedData.replace(/\D/g, '');
            pastedData = pastedData.slice(0, maxLengthNumber);

            $(this).val(pastedData).trigger('input');
        });

        // Функция установки позиции курсора
        function setCaretPosition(ctrl, pos) {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(pos, pos);
            } else if (ctrl.createTextRange) {
                var range = ctrl.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        }
    }

    // ========================================
    // Проверка заполнения расчётного счёта
    // ========================================

    $inputNumber.on('input change', function() {
        $('.number__error').hide();

        updateContinueButton();
    });

    // ========================================
    // Кнопка продолжения
    // ========================================

    $('.js-button-number').on('click', function(e) {
        e.preventDefault();

        var currentBik = String($inputBik.val() || '');
        var currentNumber = String(
            $('#card__number-new').val() || ''
        ).replace(/\D/g, '');

        // Проверяем, что БИК прошёл проверку
        if (
            !bikUser ||
            bikUser !== currentBik ||
            !korChetUser ||
            !bankName.toLowerCase().includes('сбербанк') ||
            currentNumber.length !== 20
        ) {
            updateContinueButton();
            return;
        }

        const bik = bikUser;

        let error = {
            code: '',
            message: ''
        };

        // Проверяем контрольное число расчётного счёта
        if (
            validateRs(
                $('#card__number-new').val(),
                bik,
                error
            )
        ) {
            // Сохраняем данные
            $.ajax({
                type: 'POST',
                url: '/ajax/save-card-number',

                data: {
                    'paymentType': 'PAYMENT_TO_ACCOUNT',
                    'card-number': $('[name ="card-number"]').val(),
                    'bik': $('[name ="card-bik"]').val(),
                    'kor_number': korChetUser,
                    'bank_name': bankName,
                    'bank_index': bank_index,
                    'bank_city': bank_city,
                    'bank_address': bank_address,
                    'bank_phone': bank_phone
                },

                dataType: 'json',

                success: function(data) {
                    if (data) {
                        let link = $('.js-button-number').attr('href');

                        location.href = link;
                    } else {
                        $('.number__error')
                            .text('Что то пошло не так. Попробуйте снова')
                            .show();
                    }
                },

                error: function(error) {
                    console.log(error);
                }
            });
        } else {
            // Ошибка валидации расчётного счёта
            $('.number__error--score').show();

            $.ajax({
                type: 'POST',
                url: '/ajax/card-number-validation-error',

                data: {
                    'card-number': $('[name ="card-number"]').val(),
                    'bik': $('[name ="card-bik"]').val(),
                    'kor_number': korChetUser,
                    'bank_name': bankName,
                    'bank_index': bank_index,
                    'bank_city': bank_city,
                    'bank_address': bank_address,
                    'bank_phone': bank_phone
                },

                dataType: 'json',

                success: function() {
                    console.log('Вы ошиблись');
                },

                error: function(error) {
                    console.log(error);
                }
            });
        }
    });

    // ========================================
    // Проверка после вставки и ввода
    // ========================================

    $inputNumber.on('keyup', function() {
        updateContinueButton();
    });

    // ========================================
    // Валидация расчётного счёта
    // ========================================

    function validateRs(rs, bik, error) {
        var result = false;

        if (typeof rs === 'number') {
            rs = rs.toString();
        } else if (typeof rs !== 'string') {
            rs = '';
        }

        if (!rs.length) {
            error.code = 1;
            error.message = 'Р/С пуст';
        } else if (/[^0-9]/.test(rs)) {
            error.code = 2;
            error.message = 'Р/С может состоять только из цифр';
        } else if (rs.length !== 20) {
            error.code = 3;
            error.message = 'Р/С может состоять только из 20 цифр';
        } else {
            var bikRs = bik.toString().slice(-3) + rs;

            var checksum = 0;

            var coefficients = [
                7, 1, 3,
                7, 1, 3,
                7, 1, 3,
                7, 1, 3,
                7, 1, 3,
                7, 1, 3,
                7, 1, 3,
                7, 1
            ];

            for (var i in coefficients) {
                checksum += coefficients[i] * (bikRs[i] % 10);
            }

            if (checksum % 10 === 0) {
                result = true;
            } else {
                error.code = 4;
                error.message = 'Неправильное контрольное число';
            }
        }

        return result;
    }
});
